import warehouseService from "@/services/warehouse";

export default {
    data() {
        return {
            inventory: [],
            loading: false,
            loadTimeout: null,
            loadCount: 0,
        };
    },
    methods: {
        debouncedLoad() {
            if (this.loadTimeout) {
                clearTimeout(this.loadTimeout);
            }
            const delay = this.loadCount === 0 ? 200 : 600;
            this.loadTimeout = setTimeout(() => {
                this.load();
            }, delay);
        },

        mergeInventories(inventoryResponses) {
            const groceries = [];
            (inventoryResponses || []).forEach((inventory) => {
                (inventory.data || []).forEach(grocery => {
                    const existingGroceryIndex = groceries.findIndex(g => g.id === grocery.id);
                    if (existingGroceryIndex === -1) {
                        groceries.push({
                            ...grocery,
                            quantity: parseFloat(grocery.quantity || 0),
                            stock: parseFloat(grocery.stock || 0),
                        });
                    } else {
                        groceries[existingGroceryIndex].quantity += parseFloat(grocery.quantity || 0);
                        groceries[existingGroceryIndex].stock += parseFloat(grocery.stock || 0);
                    }
                })
            });
            return groceries;
        },
        async load() {
            if (!this.filters.warehouse?.length || this.loading) return;

            this.loading = true;
            this.loadCount++;

            // Resetuj inventory pre učitavanja novih podataka
            this.inventory = [];

            try {
                const method =
                    this.filters.showType === "daily" ? "getWarehouseReport" : "getWarehouseReportV2";
                const promises = this.filters.warehouse.map((warehouse) =>
                    warehouseService[method](this.filters.showType, this.restaurant.id, {
                        date_from: this.filters.dates.from,
                        date_to: this.filters.dates.to,
                        warehouse_id: warehouse.id,
                    }));
                const inventoryResponses = await Promise.all(promises);
                this.inventory = this.mergeInventories(inventoryResponses);
            } catch (e) {
                console.error("Error loading warehouse requirements:", e);
                this.showErrorSnackbar(this.$t("error_loading_warehouse_requirements"));
                this.inventory = []; // Resetuj i u slučaju greške
            } finally {
                this.loading = false;
            }
        },
    },
    beforeDestroy() {
        // Cleanup timeout da se spreči memory leak
        if (this.loadTimeout) {
            clearTimeout(this.loadTimeout);
        }
    },
};
